import { useState, useCallback } from 'react';
import { UseDrawerType } from './interfaces';

export const useDrawer: UseDrawerType = () => {
  const [open, setOpen] = useState(false);

  const openDrawer = useCallback(() => setOpen(true), [setOpen]);

  const closeDrawer = useCallback(() => setOpen(false), [setOpen]);

  const toggleDrawer = useCallback(
    () => setOpen((prevState) => !prevState),
    [setOpen],
  );

  return { open, openDrawer, closeDrawer, toggleDrawer };
};
